import React from "react";
import BaseCommissionsSubsidiesComponent from "./BaseCommissionsSubsidiesComponent";

const visibleColumns = ["Name", "CalculationName", "Percent", "Amount", "Currency", "PartnerName"];
const SubsidiesComponent = props => <BaseCommissionsSubsidiesComponent visibleColumns={visibleColumns} {...props} />;

SubsidiesComponent.defaultProps = {
  isSubsidy: true
};

SubsidiesComponent.propTypes = {};

export default SubsidiesComponent;
